var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0C24.8366 0 32 7.16337 32 16C32 24.8366 24.8366 32 16 32C7.16337 32 0 24.8366 0 16C0 7.16337 7.16337 0 16 0ZM23.3969 10.0622L21.0574 21.8589C21.0574 21.8589 20.7299 22.6768 19.83 22.2841L14.4063 18.1329C15.1352 17.4773 20.7906 12.393 21.038 12.1625C21.42 11.8056 21.1826 11.5933 20.7386 11.8632L12.3848 17.1679L9.16227 16.0833C9.16227 16.0833 8.65503 15.9029 8.60618 15.5103C8.55671 15.1177 9.17855 14.9054 9.17855 14.9054L22.3167 9.75155C22.3167 9.75155 23.3969 9.27687 23.3969 10.0622V10.0622Z",
    fill: "#6E7E9D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0b053e805da32ff8863b070f62312b53.svg";
export { ForwardRef as ReactComponent };